/**
 * §58 — the one message every gated feature shows, everywhere (DEC-366).
 *
 * "This feature is not available on your current plan. Contact Paelode support for more
 * information." plus the support address as a mailto link. No feature-specific copy, no tier
 * names, no pricing hints and no self-serve upgrade path: commercial conversations happen
 * outside the product.
 *
 * The address is the platform's configured support contact (OPEN-109, useSupportEmail), so
 * it follows the setting rather than a hard-coded mailbox.
 */

import * as React from 'react';
import { useSupportEmail } from './support-contact.js';

export function GatedFeaturePrompt(): React.JSX.Element {
  const email = useSupportEmail();
  return (
    <div
      role="status"
      data-testid="gated-feature-prompt"
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '32px',
        textAlign: 'center',
        backgroundColor: 'var(--color-bg-secondary)',
      }}
    >
      <p
        style={{ fontSize: '16px', fontWeight: 600, color: 'var(--color-text-primary)', margin: 0 }}
      >
        This feature is not available on your current plan.
      </p>
      <p
        style={{
          fontSize: '14px',
          color: 'var(--color-text-secondary)',
          margin: 0,
          maxWidth: '360px',
        }}
      >
        Contact Paelode support for more information.
      </p>
      <a href={`mailto:${email}`} style={{ fontSize: '14px' }}>
        {email}
      </a>
    </div>
  );
}
